import { ICON_COLOR, ICON_HEIGHT_20, IconNG } from '../../../../Icon'
import { SelectDropdownEntityListItemIcons } from '../../../../Select'
import {
  getEmailRecipientFieldSelectItemIcon,
  isEmailRecipientAdditional,
} from '../../EmailRecipientsField.utils'

function EmailRecipientsSelectDropdownItemIcons({
  isArchived,
  isSelected,
  value,
}) {
  const Icon = isEmailRecipientAdditional(value)
    ? getEmailRecipientFieldSelectItemIcon(value)
    : null

  return (
    <SelectDropdownEntityListItemIcons
      isArchived={isArchived}
      isSelected={isSelected}
    >
      {Icon ? (
        <IconNG
          Icon={Icon}
          color={ICON_COLOR.SecondaryTextColor}
          size={ICON_HEIGHT_20}
        />
      ) : null}
    </SelectDropdownEntityListItemIcons>
  )
}

export default EmailRecipientsSelectDropdownItemIcons
